module.exports = __webpack_public_path__ + "static/img/album4_202601_02.a938c2e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/csr/fight-epidemic/album4_202601_02.jpg
// module id = GkJC
// module chunks = 100